import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from '../../services/apiClient';
import { GetTags } from "../../config/config";
export const fetchAllstatus = createAsyncThunk(
  'status/fetchAllstatus',
  async (_arg: any, { rejectWithValue }) => {
    try {
      const response = await apiClient.get(GetTags, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'mode': 'outlook'
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const statusSlice = createSlice({
  name: 'status',
  initialState: {
    status: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllstatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllstatus.fulfilled, (state, action) => {
        state.loading = false;
        state.status = action.payload;
      })
      .addCase(fetchAllstatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default statusSlice.reducer;
